/* eslint-disable complexity */
export class ECGCaptureBuffer {
  private parts: Uint8Array[] = [];
  private totalBytes = 0; // ile bajtów trafiło do bufora od startu

  public start() {
    this.parts = [];
    this.totalBytes = 0;
  }
  public pushDataView(dv: DataView) {
    const u8 = new Uint8Array(dv.buffer, dv.byteOffset, dv.byteLength);
    const copy = new Uint8Array(u8); // kopia 1:1
    this.parts.push(copy);
    this.totalBytes += copy.length; // <— NOWE: licznik bajtów
  }

  /** Zwraca aktualną pozycję w buforze (liczoną w bajtach) jako znacznik startu. */
  public createMark(): number {
    return this.totalBytes;
  }

  /**
   * Zwraca pełne pakiety 20B jako kopie Uint8Array, bez ogona.
   * @param options.filterStatus  jeśli true, pomija pakiety z bitem 7 w pierwszym bajcie (h0&0x80)
   * Jeśli sprzęt jest w wariancie 10×Uint16LE (bez nagłówków), w getParts20B ustawisz po prostu filterStatus: false.
   * @param options.fromByte      bajtowa pozycja startu (np. wynik createMark())
   */
  public getParts20B(options?: {
    filterStatus?: boolean;
    fromByte?: number;
  }): Uint8Array[] {
    const { filterStatus = false, fromByte = 0 } = options || {};
    const PACKET_BYTES = 20;

    // szybka ścieżka: jeśli wszystkie parts są 20B, tylko przytnij ogon
    //const total = this.parts.reduce((n, c) => n + c.length, 0);
    //const tail = total % PACKET_BYTES;

    const out: Uint8Array[] = [];
    let carry: Uint8Array | null = null;
    let skip = Math.max(0, fromByte); // pomijane bajty z początku bufora (dojście do „marka”)

    for (const part of this.parts) {
      if (!part || part.length === 0) {
        continue;
      }

      // 1) SKIP: przeskocz fragmenty aż do fromByte
      let slice = part;
      if (skip > 0) {
        if (skip >= slice.length) {
          skip -= slice.length;
          continue;
        }
        slice = slice.subarray(skip);
        skip = 0;
      }

      // 2) sklej carry + bieżący fragment
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const buf: any = carry
        ? (() => {
            const m = new Uint8Array(carry.length + slice.length);
            m.set(carry, 0);
            m.set(slice, carry.length);
            carry = null;
            return m;
          })()
        : slice;

      // 3) wytnij pełne 20B pakiety
      const full = Math.floor(buf.length / PACKET_BYTES);
      const used = full * PACKET_BYTES;

      for (let p = 0; p < full; p++) {
        const start = p * PACKET_BYTES;
        const pkt = buf.subarray(start, start + PACKET_BYTES);

        if (filterStatus && pkt[0] & 0x80) {
          continue;
        } // packed12: pomiń statusowe ramki
        out.push(new Uint8Array(pkt)); // kopia 20B
      }

      // 4) reszta (<20B) przechodzi na następną iterację
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const rest: any = buf.length - used;
      carry = rest > 0 ? buf.slice(used) : null;
    }
    // ogon <20B pomijamy
    return out;
  }
}
